import React from 'react';
import { Layout } from 'antd';
import logo from '../assets/logo.png';

const { Content, Footer } = Layout;

const LayoutLogin: React.FC<{
  children: React.ReactNode,
}> = ({children}) => {
  return (
    <Layout style={{ height: '100vh', backgroundColor: '#151c26' }}>
      <Content style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <div style={{ width: 600, margin: 10 }}>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginRight: 16, height: 120 }}>
            <img src={logo} alt="Logo" style={{ width: 100, height: 'auto' }} />
            <div style={{ color: 'white', fontSize: 20, fontWeight: 'bold' }}></div>
          </div>
          <div>
            {children}
          </div>
        </div>

      </Content>
      <Footer style={{ textAlign: 'center' }}>
        ©{new Date().getFullYear()} Developed by PiPIoT.
      </Footer>
    </Layout>
  );
};

export default LayoutLogin;